import { render } from "./Pillbox.vue?vue&type=template&id=5190eb2d&scoped=true"
import script from "./Pillbox.vue?vue&type=script&lang=js"
export * from "./Pillbox.vue?vue&type=script&lang=js"

import "./Pillbox.vue?vue&type=style&index=0&id=5190eb2d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5190eb2d"]])

export default __exports__